<template>
  <div class="tools-partners-partners">
    <div class="row justify-content-between">
      <div class="d-flex align-items-center col-lg-6 order-1 order-lg-0">
        <span class="table-quantity-counter mr-5">
          Total: {{ pagination.count }}
        </span>
        <button class="btn p-0 table-refresh" @click="dispatch">
          <i class="fa-solid fa-refresh" />
        </button>
      </div>

      <div class="col-lg-4 d-flex align-items-center mb-6 mb-lg-0">
        <search-filter
          :show-results-dropdown="false"
          placeholder="Pesquisar"
          class="flex-fill"
          @search="onSearch"
          new-design
        />
      </div>
    </div>

    <div v-if="loading" class="text-center my-9">
      <b-spinner variant="primary" />
    </div>

    <div
      v-else-if="!pagination.count"
      class="container centralize-row text-center pt-5"
    >
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <img
            class="d-block mb-9 mx-auto"
            src="@/assets/images/home/welcome.png"
          />
          <h5>Você ainda não tem colaboradores</h5>
          <div class="text-secondary mb-5">
            Clique no botão acima para convidar
          </div>
        </div>
      </div>
    </div>

    <div v-else>
      <!-- descktop area -->
      <data-table
        new-design
        class="d-none d-lg-block"
        columnsFr="1fr 1fr 1fr 0.4fr 0.1fr"
        :data="partners"
        :columns="columns"
      >
        <template #default="{ item }">
          <span>
            {{ item.user.name }}
          </span>
          <span>
            {{ item.user.email }}
          </span>
          <span>
            {{ profile(item) }}
          </span>
          <div>
            <span :class="item.is_blocked ? 'inactive-badge' : 'active-badge'">
              {{ item.is_blocked ? "Bloqueado" : "Aprovado" }}
            </span>
          </div>
          <div class="d-flex justify-content-end">
            <actions-dropdown
              :left="false"
              :right="true"
              :actions="actions(item)"
              @edit="edit(item)"
              @block="block(item)"
            />
          </div>
        </template>
      </data-table>
      <!-- end of desktop -->
      <!-- mobile area -->
      <data-table
        new-design
        class="d-lg-none"
        :data="partners"
        :columns="['', '']"
      >
        <template #default="{ item }">
          <div class="d-flex flex-column py-5 responsive-table">
            <small>
              <strong>Nome do Colaborador: </strong>
              {{ item.user.name }}
            </small>
            <small>
              <strong>E-mail: </strong>
              {{ item.user.email }}
            </small>
            <small>
              <strong>Perfil: </strong>
              {{ profile(item) }}
            </small>
            <small class="d-flex align-items-center">
              <strong>Status: </strong>
              <span
                :class="item.is_blocked ? 'inactive-badge' : 'active-badge'"
              >
                {{ item.is_blocked ? "Bloqueado" : "Aprovado" }}
              </span>
            </small>
          </div>
          <div class="d-flex align-items-center justify-content-end">
            <actions-dropdown
              :actions="actions(item)"
              @edit="edit(item)"
              @block="block(item)"
            />
          </div>
        </template>
      </data-table>
      <!-- end of mobile -->
    </div>

    <div class="mt-5 d-flex justify-content-end">
      <paginator
        v-show="partners.length && !loading"
        :pagination="pagination"
        @on-update="dispatch"
      />
    </div>

    <responsive-modal v-model="dialog" size="lg">
      <invite-modal v-if="dialog" :item="itemToEdit" @close="dialog = false" />
    </responsive-modal>
  </div>
</template>

<script>
import InviteModal from "./InviteModal";

import { updateArrayItem } from "@/functions/helpers";
import { mapState } from "vuex";

export default {
  components: { InviteModal },
  data() {
    return {
      search: "",
      dialog: false,
      loading: false,
      itemToEdit: null,
      columns: ["Colaborador", "E-mail", "Perfil", "Status", ""],
      pagination: { count: 0 }
    };
  },
  computed: {
    ...mapState("partnersCenter", ["partners"])
  },
  mounted() {
    this.dispatch();
  },
  watch: {
    dialog(v) {
      if (!v) this.itemToEdit = null;
    }
  },
  methods: {
    actions(item) {
      return [
        {
          text: "Editar",
          icon: "fa-solid fa-pen",
          confirmation: {
            enable: false
          },
          event: "edit"
        },
        ...[
          item.is_blocked
            ? {
                text: "Desbloquear acesso",
                class: "text-success",
                icon: "fa-solid fa-lock-open",
                confirmation: {
                  enable: true,
                  newDesign: true,
                  submitText: "Desbloquear acesso",
                  submitButtonClass: "btn-success",
                  text:
                    "Tem certeza que deseja desbloquear o acesso deste colaborador?"
                },
                event: "block"
              }
            : {
                text: "Bloquear acesso",
                class: "text-danger",
                icon: "fa-solid fa-lock",
                confirmation: {
                  enable: true,
                  newDesign: true,
                  submitText: "Bloquear acesso",
                  submitButtonClass: "btn-danger",
                  text:
                    "Tem certeza que deseja bloquear o acesso deste colaborador?"
                },
                event: "block"
              }
        ]
      ];
    },
    onSearch(search) {
      this.search = search;
      this.dispatch();
    },
    profile(item) {
      return item.is_admin ? "Administrador" : item.perfil?.name;
    },
    dispatch(offset = null) {
      this.loading = true;
      this.$store
        .dispatch("partnersCenter/getPartners", {
          offset,
          search: this.search
        })
        .then(({ count, next, previous }) => {
          this.pagination = { count, next, previous };
        })
        .finally(() => {
          this.loading = false;
        });
    },
    edit(item) {
      this.itemToEdit = {
        ...item,
        email: item.user?.email,
        name: item.user?.name,
        perfil_id: item.perfil?.id
      };
      this.dialog = true;
    },
    block(item) {
      this.$store
        .dispatch("partnersCenter/putPartner", {
          id: item.id,
          is_blocked: !item.is_blocked
        })
        .then(data => {
          this.$store.commit(
            "partnersCenter/setPartners",
            updateArrayItem(this.partners, data)
          );
          this.$message.success(
            `Colaborador ${item.is_blocked ? "desbloqueado" : "bloqueado"}.`
          );
        })
        .catch(() => this.$message.error("Erro ao atualizar colaborador"));
    }
  }
};
</script>
